import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-layout-one-column',
  templateUrl: './layout-one-column.component.html',
})
export class LayoutOneColumnComponent {
  @Input() header!: string;
}
